export default __webpack_public_path__ + "media/images/features/ana/shimane-0ab622eb09d8a6f2f123ec1de7e0fbf7.png";